import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M143 256.28l-136-136A23.88 23.88 0 017 86.4l22.59-22.6a23.91 23.91 0 0133.89 0L160 160.11l96.37-96.37a23.91 23.91 0 0133.89 0L313 86.34a23.88 23.88 0 010 33.88l-136 136a23.91 23.91 0 01-34 .1z" /></svg>);